import { SVButton } from '@/components/core';
import { CreateTransactionRequest } from '@/types/transactionRequests';
import { Box } from '@mui/material';
import { useFormContext } from 'react-hook-form';

type CreateTransactionFooterProps = {
  isConfirming: boolean;
  setIsConfirming: React.Dispatch<React.SetStateAction<boolean>>;
  isCreateTransactionPending: boolean;
  handleSubmit: (data: CreateTransactionRequest) => Promise<void>;
  handleCancel: () => void;
};

export default function CreateTransactionFooter({
  isConfirming,
  setIsConfirming,
  isCreateTransactionPending,
  handleSubmit,
  handleCancel,
}: CreateTransactionFooterProps) {
  const formMethods = useFormContext<CreateTransactionRequest>();

  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', mt: 2 }}>
      <SVButton
        onClick={() => (isConfirming ? setIsConfirming(false) : handleCancel())}
        variant="outlined"
        breadcrumbLabel={isConfirming ? 'Back' : 'Cancel'}
        aria-label={`${isConfirming ? 'Edit' : 'Cancel'} transfer request`}>
        {isConfirming ? 'Back' : 'Cancel'}
      </SVButton>
      <SVButton
        isLoading={isCreateTransactionPending}
        variant="primary"
        breadcrumbLabel={isConfirming ? 'Submit' : 'Next'}
        aria-label={
          isConfirming ? 'Submit transfer request' : 'View Transfer Details'
        }
        onClick={
          isConfirming
            ? formMethods.handleSubmit(handleSubmit)
            : formMethods.handleSubmit(() => setIsConfirming(true))
        }>
        {isConfirming ? 'Submit' : 'Next'}
      </SVButton>
    </Box>
  );
}
